import ContactListView from './ContactListView.html';
import { ContactListController } from './ContactListController';
const ContactListComponent = {
    template: ContactListView,
    transclude: true,
    controllerAs: '$ctrl',
    controller: ContactListController,
    bindings: {
        contacts: '<',
        listContact: '<',
        checkedContacts: '<?',
        blockableContacts: '=?',
        checkableContacts: '=?',
        disposableContacts: '=?',
        size: '@?',
        onContactDispose: '&?',
        onSearchBots: '&?',
        flowCheckedRouter: '&',
        flowUncheckedRouter: '&',
        blockingRule: '<?',
        blockedWarning: '@?',
        isMoving: '<?',
        addCounter: '&',
        deleteCounter: '&',
    },
};
export default ContactListComponent;
